<template>
    <div class="container">
        <div class="page-content mt-10">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading text-dark">
                        {{ $t('marketplace.title') }}
                    </h1>
                </div>

                <div class="col-4">
                    <a :class="'btn btn-'+(activeTab === 'available' ? 'info' : 'dark')+' w-100'" v-on:click="activeTab = 'available'" id="current-tab" data-bs-toggle="tab" type="button" role="tab" aria-controls="home" aria-selected="true">
                        {{ $t('marketplace.tabs.browse') }}
                    </a>
                </div>

                <div class="col-4">
                    <a :class="'btn btn-'+(activeTab === 'own' ? 'info' : 'dark')+' w-100'" v-on:click="activeTab = 'own'" id="sets-tab" data-bs-toggle="tab" type="button" role="tab" aria-controls="profile" aria-selected="false">
                        {{ $t('marketplace.tabs.yours') }}
                    </a>
                </div>

                <div class="col-4">
                    <a :class="'btn btn-'+(activeTab === 'create' ? 'info' : 'dark')+' w-100'" v-on:click="activeTab = 'create'" id="sets-tab" data-bs-toggle="tab" type="button" role="tab" aria-controls="profile" aria-selected="false">
                        {{ $t('marketplace.tabs.create') }}
                    </a>
                </div>

                <div class="col-12" v-show="activeTab === 'available'">
                    <h5 class="mb-2 mt-4">{{ $t('marketplace.currentOffers') }}</h5>
                    <a href="javascript:" class="float-end" v-on:click="fetchOffersSummary(true)" style="margin-top: -2.25em">
                        <i class="fa-solid fa-refresh"></i>
                    </a>

                    <div class="text-center" v-if="offeredCards === null">
                        <loading-spinner/>
                    </div>

                    <div class="alert alert-info" v-if="offeredCards !== null && offeredCards.length === 0">
                        {{ $t('marketplace.noOffers') }}
                    </div>

                    <div class="form-group" v-if="offeredCards && offeredCards.length > 0">
                        <input type="search" class="form-control" v-model="searchTerm" :placeholder="$t('marketplace.search')">
                    </div>

                    <div class=" my-1 form-check background-layered" v-if="offeredCards && offeredCards.length > 0">
                        <label for="desc" class="form-check-label">{{ $t('marketplace.onlyUnowned') }}</label>
                        <input type="checkbox" id="desc" class="form-check-input" v-model="onlyUnowned">
                    </div>

                    <div class="row p-0">
                        <router-link class="col-6 col-sm-4 col-md-4 col-lg-3 col-xl-2 col-xxl-2 p-1 card-link text-light" v-for="card in filteredAvailableCards" :to="{ name: 'marketplace-card', params: { card_id: card.cardId }}">
                            <img loading="lazy" :src="CardService.getSmallCardImageUrlByCardID(card.cardId)" alt="" class="w-100 card-image"><br/>
                            <p class="m-0 mt-1 mb-2 text-center marketplace-card-short-info">
                                <span class="card-name w-100">
                                    {{ card.cardName }}
                                </span><br/>
                                <small class="muted">
                                    <i class="owned-icon fa-solid fa-check-circle text-success" v-if="card.isInSetCollection"></i>
                                    <i class="owned-icon fa-solid fa-times-circle text-danger" v-else></i> |
                                    {{ $t('marketplace.from') }} <strong>{{ card.lowestPrice }}</strong> <currency-icon/> |
                                    {{ card.offerCount + ' ' + (card.offerCount > 1 ? 'offers' : 'offer') }}
                                </small>


                                <!--                                <img :src="CardService.getSetSymbolUrlByCardID(card.cardId)" alt="set-symbol" class="ms-1 set-icon-small"> |-->
                            </p>
                        </router-link>
                    </div>
                </div>

                <div class="col-12" v-show="activeTab === 'own'">
                    <h5 class="mb-1 mt-4">{{ $t('marketplace.my') }}</h5>

                    <div class="alert alert-info" v-if="ownOffers && ownOffers.length === 0">
                        {{ $t('marketplace.noActiveOffers') }}
                    </div>

                    <div class="row p-0 m-0">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 p-1 m-0" v-for="offer in ownOffers">
                            <div class="card mb-3">
                                <div class="card-body row p-3">
                                    <div class="row m-0 p-0">
                                        <div class="col-sm-8 col-7 row p-0">
                                            <div class="ps-0 col-12">
                                                <h6>{{ $t('marketplace.cardInfo.name') }}</h6>
                                                <span v-text="offer.card.name"></span>
                                            </div>
                                            <div class="mt-2 ps-0 col-md-7 col-sm-7 col-12 text-nowrap">
                                                <h6>{{ $t('marketplace.cardInfo.set') }}</h6>
                                                <span v-text="offer.card.set.name"></span><br/>
                                                <small class="muted">
                                                    <span v-text="offer.card.set.series"></span><br/>
                                                    <small class="muted" v-text="offer.card.set.releaseDate"></small>
                                                </small>
                                            </div>

                                            <div class="mt-2 ps-0 col-5 d-none d-sm-block">
                                                <h6>&nbsp;</h6>
                                                <img :src="CardService.getSetLogoUrl(offer.card)" class="card-set-logo" alt="set-logo"/>
                                            </div>

                                            <div class="mt-2 ps-0 col-sm-7 col-12">
                                                <h6>{{ $t('marketplace.cardInfo.price') }}</h6>

                                                <span>
                                                {{ offer.price }} <currency-icon/>
                                            </span>
                                            </div>

                                            <div class="mt-2 ps-0 col-sm-7 col-12">
                                                <h6>{{ $t('marketplace.cardInfo.created') }}</h6>

                                                <span>
                                                {{ getCreatedAt(offer) }}<br/>
                                                <small class="muted">{{ getTimestamp(offer) }}</small>
                                            </span>
                                            </div>
                                        </div>

                                        <div class="col-sm-4 col-5 ps-0 pe-0">
                                            <img :src="CardService.getCardImageUrl(offer.card)" class="card-preview" alt="">
                                        </div>

                                        <div class="col-12 p-0 mt-3">
                                            <button href="javascript:" v-if="offer.user_id === $store.state.user.user_id" v-on:click="deleteOffer(offer)" class="btn btn-sm btn-dark w-100 mt-2">
                                                {{ $t('marketplace.cardInfo.delete') }} <i class="fa-solid fa-trash"></i>
                                            </button>
                                            <button v-else class="btn btn-sm btn-danger w-100" v-on:click="purchase(offer)">{{ $t('marketplace.cardInfo.buy') }} <strong>{{ offer.price }}
                                                <currency-icon/>
                                            </strong></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12" v-show="activeTab === 'create'">
                    <h5 class="mt-4">{{ $t('marketplace.create') }}</h5>

                    <div class="alert alert-info" v-if="cards.length && cards.length === 0">
                        {{ $t('marketplace.noCards') }}
                    </div>
                    <template v-else>
                        <p class="alert alert-info">{{ $t('marketplace.choose') }}</p>

                        <div class="alphabet-navigation-wrapper my-2" v-if="cards.length >= minimumCardsForAlphabetScroller">
                            <a v-for="letter in alphabet" v-show="Object.keys(cardsByLetter).includes(letter)" :href="'#'+letter" v-text="letter"></a>
                        </div>

                        <div class="card-gallery-wrapper">
                            <div v-for="(letterGroup, letter) in cardsByLetter">
                                <span class="letter-title" v-text="letter" :id="letter" v-if="cards.length >= minimumCardsForAlphabetScroller"></span>
                                <div class="cards-per-letter-wrapper">
                                    <div v-for="card in letterGroup">
                                        <img class="gallery-card" :src="CardService.getSmallCardImageUrl(card)" alt="" v-on:click="startOfferCreationDialog(card)"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div v-if="cardToOffer !== null" class="modal fade" id="create-offer-modal" tabindex="-1" aria-labelledby="#create-offer-modal-label" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="create-offer-modal-label">{{ $t('marketplace.createOffer') }}</h1>
                        <button type="button" class="btn-close text-reset" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                        <div class="row m-0 p-0">
                            <div class="col-sm-4 col-5 ps-0">
                                <img :src="CardService.getCardImageUrl(cardToOffer)" class="card-preview" alt="">
                            </div>
                            <div class="col-sm-8 col-7 row p-0">
                                <div class="ps-0 col-12">
                                    <h6>{{ $t('marketplace.cardInfo.name') }}</h6>
                                    <span v-text="cardToOffer.name"></span>
                                </div>
                                <div class="mt-2 ps-0 col-md-7 col-sm-7 col-12 text-nowrap">
                                    <h6>{{ $t('marketplace.cardInfo.set') }}</h6>
                                    <span v-text="cardToOffer.set.name"></span><br/>
                                    <small class="muted">
                                        <span v-text="cardToOffer.set.series"></span><br/>
                                        <small class="muted" v-text="cardToOffer.set.releaseDate"></small>
                                    </small>
                                </div>

                                <div class="mt-2 ps-0 col-5 d-none d-sm-block">
                                    <h6>&nbsp;</h6>
                                    <img :src="CardService.getSetLogoUrl(cardToOffer)" class="card-set-logo" alt="set-logo"/>
                                </div>

                                <div class="mt-2 ps-0 col-sm-5 col-12">
                                    <h6>{{ $t('marketplace.cardInfo.value') }}</h6>
                                    <span v-text="CardService.getPrice(cardToOffer)"></span>
                                    <currency-icon/>
                                </div>

                                <div class="mt-2 ps-0 col-sm-7 col-12">
                                    <h6>{{ $t('marketplace.cardInfo.inCollection') }}</h6>
                                    <span v-if="cardToOffer.is_in_set_collection">
                                        {{ $t('marketplace.cardInfo.yes') }} <i class="fa-solid fa-check-circle text-success"></i>
                                    </span>
                                    <span v-else>
                                        {{ $t('marketplace.cardInfo.no') }} <i class="fa-solid fa-times-circle text-danger"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="mt-4">
                            <div class="form-group">
                                <h6>
                                    {{ $t('marketplace.cardInfo.price') }} <currency-icon/>
                                </h6>
                                <input min="0" max="1000000" type="number" class="form-control text-end pe-2" v-model="offerPrice">
                            </div>

                            <div class="alert alert-info">
                                {{ $t('marketplace.info') }}
                            </div>

                            <div class="mt-2">
                                <a href="javascript:" v-on:click="submitCard()" class="btn btn-success w-100">
                                    {{ $t('marketplace.offer') }}
                                </a>
                                <button class="btn btn-danger w-100 mt-2" data-bs-dismiss="modal">
                                    {{ $t('marketplace.cancel') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardService from "../../CardService";
import CurrencyIcon from "../parts/CurrencyIcon.vue";
import axios from "axios";
import iziToast from "izitoast";
import LoadingSpinner from "../parts/LoadingSpinner.vue";

export default {
    name: "Marketplace",
    components: {LoadingSpinner, CurrencyIcon},
    data() {
        return {
            activeTab: 'available',
            cardToOffer: null,
            ownOffers: [],
            offeredCards: null,
            offerPrice: 0,
            minimumCardsForAlphabetScroller: 15,
            searchTerm: '',
            onlyUnowned: false
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.$store.commit('updateUserCards');

        this.fetchOffersSummary();
        this.fetchOwnOffers();
    },
    computed: {
        CardService() {
            return CardService;
        },
        cards() {
            return this.$store.state.collection.cards?.sort((a, b) => a.name.localeCompare(b.name)) ?? [];
        },
        cardsByLetter() {
            let result = {}

            for (let i = 0; i < this.cards.length; i++) {
                let currentWord = this.cards[i].name;
                let firstChar = currentWord[0].toUpperCase();
                let innerArr = [];

                if (result[firstChar] === undefined) {
                    innerArr.push(this.cards[i]);
                    result[firstChar] = innerArr
                } else {
                    result[firstChar].push(this.cards[i])
                }
            }

            return result
        },
        alphabet() {
            return [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];
        },
        filteredAvailableCards() {
            if (!this.offeredCards) {
                return [];
            }

            let cards = this.offeredCards;

            if (this.offeredCards && this.searchTerm.trim().length > 0) {
                cards = this.offeredCards.filter(c => c.cardName.toLowerCase().search(this.searchTerm.toLowerCase()) !== -1);
            }

            if (this.offeredCards && this.onlyUnowned) {
                cards = cards.filter(c => !c.isInSetCollection);
            }

            return cards;
        }
    },
    methods: {
        fetchOffersSummary(manual = false) {
            axios.get('/api/marketplace/summary').then((response) => {
                this.offeredCards = Object.values(response.data);

                if (manual) {
                    iziToast.success({title: this.$i18n.t('marketplace.notifications.refreshed'), position: 'topCenter'})
                }
            })
        },
        fetchOwnOffers(manual = false) {
            axios.get('/api/marketplace/my').then((response) => {
                this.ownOffers = response.data.map((offer) => {
                    offer.card = JSON.parse(offer.card.json);
                    return offer;
                });

                if (manual) {
                    iziToast.success({title: this.$i18n.t('marketplace.notifications.refreshed'), position: 'topCenter'})
                }
            })
        },
        submitCard() {
            axios.post('/api/marketplace/offers', {
                card: this.cardToOffer.model.id,
                price: this.offerPrice
            }).then(response => {
                iziToast.success({title: this.$i18n.t('marketplace.notifications.added')});
                $("#create-offer-modal").modal('hide');

                this.$store.commit('updateUserCards');
                this.fetchOwnOffers();
            })
        },
        startOfferCreationDialog(card) {
            this.cardToOffer = card;
            this.offerPrice = CardService.getPrice(card)

            setTimeout(() => {
                $("#create-offer-modal").modal('show');
            }, 100);
        },
        getCreatedAt(offer) {
            return moment(offer.created_at).fromNow();
        },
        getTimestamp(offer) {
            return moment(offer.created_at).format('YYYY-MM-DD hh:mm');
        },
        deleteOffer(offer) {
            axios.post('/api/marketplace/delete', {
                id: offer.id
            }).then(response => {
                iziToast.success({title: this.$i18n.t('marketplace.notifications.deleted')});

                this.$store.commit('updateUserCredits');
                this.$store.commit('updateUserCards');
                this.fetchOwnOffers();
            })
        }
    },
};
</script>


<style scoped lang="scss">
.page-heading {
    background-image: url("/assets/dipocaco/pocas/market.jpg");
    background-position: center 45%;
}

.card-gallery-wrapper {
    .letter-title {
        display: inline-block;
        font-size: 1.5em;
        vertical-align: middle;
        text-align: center;
        font-weight: bold;
        margin-bottom: 0.5em;
    }

    .cards-per-letter-wrapper {
        max-width: 100%;
        overflow-y: auto;
        display: flex;
        margin-bottom: 1em;

        .gallery-card {
            display: inline-block;
            width: 9em;
            margin-right: 0.5em;
            border-radius: 5px;
        }
    }
}

.alphabet-navigation-wrapper {
    max-width: 100%;
    overflow-y: auto;
    display: flex;
    white-space: nowrap;

    a {
        padding: 0.20em 0.5em;
        margin: 0.33em 0.20em;
        min-width: 2em;
        text-align: center;
        border-radius: 5px;
        text-decoration: none;
        color: white;
        background-color: #707070;

        &:not(:last-child) {
            margin-right: 0.75em;
        }
    }
}


.card-preview {
    width: 100%;
    border-radius: 10px;
}

.form-group {
    margin-bottom: 1em;
    vertical-align: middle;

    * {
        vertical-align: middle;
    }
}

.card-set-logo {
    max-width: 100%;
    max-height: 100%;
}

.fa-solid {
    font-size: 1.5em;
}

.avatar-image {
    max-width: 7.5em;
    margin-top: -2.1em;
    margin-left: -2.1em;
}

.card-name {
    font-size: 1.3em;
}

.card-link {
    text-decoration: none;
}

.owned-icon {
    font-size: 1em;
}

.card-image {
    border-radius: 10px;
}
</style>
